import { InputSwitch } from "primereact/inputswitch";
import React from "react";
import { useTranslation } from "react-i18next";
import backbutton from "../../assets/images/backbutton.svg";
import documentcenter from "../../assets/images/documentcenter.svg";
import gridview from "../../assets/images/gridview.svg";
import listview from "../../assets/images/listview.svg";
import { getOutsideUrl } from "../../utils/getOutsideUrl";
import "./ViewCatalogueSwitchBar.css";

interface Props {
  value: boolean;
  view: "GRID" | "LIST";
  currentCategory: string;
  updateData?: any;
  docCenter?: boolean;
  mountDetail?: any;
}

const ViewCatalogueSwitchBar: React.FC<Props> = ({
  value,
  view,
  currentCategory,
  updateData,
  docCenter,
  mountDetail,
}) => {
  const { t } = useTranslation();
  return (
    <>
      {currentCategory ? (
        <div className="text-xl font-bold font-primary flex align-items-center justify-content-center">
          {currentCategory}
        </div>
      ) : (
        ""
      )}
      <section className="switch-bar flex align-items-center justify-content-between pb-3">
        <div className="flex align-items-center">
          {currentCategory && (
            <a
              onClick={() => {
                handleBack(mountDetail, updateData);
              }}
              title={t("BACK")}
              className="flex align-items-center pr-3 cursor-pointer"
            >
              <img src={backbutton} alt={t("BACK")} />
            </a>
          )}
          <div
            className={`  font-primary ${
              currentCategory
                ? "cursor-pointer text-lg font-medium"
                : "text-xl font-bold"
            }`}
            onClick={() => {
              if (currentCategory) handleBack(mountDetail, updateData);
            }}
          >
            {currentCategory
              ? t("BACK")
              : view === "GRID"
              ? t("CAT")
              : t("LIST_OF_MOUNT")}
          </div>
        </div>
        <div className="flex align-items-center">
          {currentCategory || docCenter ? (
            ""
          ) : (
            <a
              className="block mr-2 flex align-items-center cursor-pointer"
              href={getOutsideUrl("doc")}
              target={"_blank"}
              title={t("DOC_CENTER")}
            >
              <img
                alt={t("DOC_CENTER")}
                width={20}
                height={20}
                src={documentcenter}
              ></img>
            </a>
          )}
          <div className="fail-safe">{t("FAIL_SAFE")}</div>
          <InputSwitch
            className="ml-2"
            checked={value}
            onChange={() => updateData({ failSafe: !value })}
          />
          {currentCategory ? (
            ""
          ) : (
            <button
              className="flex"
              title={t(view === "GRID" ? "LIST" : "GRID")}
              onClick={() => {
                updateData({ currentView: view === "GRID" ? "LIST" : "GRID" });
              }}
            >
              <img
                alt={t(view)}
                className="ml-3"
                width={20}
                height={20}
                src={view === "GRID" ? listview : gridview}
              ></img>
            </button>
          )}
        </div>
      </section>
    </>
  );
};

export default ViewCatalogueSwitchBar;
function handleBack(mountDetail: any, updateData: any) {
  let backData = "";
  if (mountDetail) {
    const { rpm, noOfMount, kg, failSafe } = mountDetail;
    backData = `?rpm=${rpm}&noOfMount=${noOfMount}&kg=${kg}&failSafe=${failSafe}`;
  }
  if (window.location.href.includes("catalogue")) {
    window.location.href = encodeURI( window.location.href).split("?")[0] + backData;
  } else {
    window.location.href =
      window.location.href.split("?")[0] + backData ? "#/" + backData : "";
  }
  updateData({ currentCategory: "", currentView: "GRID" });
}
